import { currentEntries } from "@/mocks/homeContent";

const statusStyles: Record<string, { dot: string; text: string; chip: string }> = {
  online: {
    dot: "bg-accent-600",
    text: "text-accent-800",
    chip: "bg-accent-100 text-accent-800",
  },
  standby: {
    dot: "bg-secondary-500",
    text: "text-secondary-800",
    chip: "bg-secondary-100 text-secondary-800",
  },
  offline: {
    dot: "bg-background-400",
    text: "text-foreground-500",
    chip: "bg-background-200 text-foreground-600",
  },
};

function SectionHead({ tag, title, desc }: { tag: string; title: string; desc: string }) {
  return (
    <div className="mx-auto mb-9 max-w-3xl text-center">
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700 ring-1 ring-primary-200">
        {tag}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      <p className="mt-3 text-sm leading-6 text-foreground-600">{desc}</p>
    </div>
  );
}

function CurrentEntries() {
  return (
    <section id="current" className="relative scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHead
          tag="当前可用入口"
          title="认准这三个官方入口，换新地址不迷路"
          desc="主站、备用与归档镜像各司其职。域名迁移期间请优先使用标记为「当前在线」的正式版入口。"
        />

        {/* multi-card first-screen */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {currentEntries.map((card, idx) => {
            const st = statusStyles[card.status];
            return (
              <article
                key={card.tag}
                className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="whitespace-nowrap rounded-md bg-background-100 px-2.5 py-1 text-xs font-semibold text-foreground-700">
                    {card.tag}
                  </span>
                  <span
                    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${st.chip}`}
                  >
                    <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`}></span>
                    {card.statusText}
                  </span>
                </div>

                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                  {card.name}
                </h3>
                <p className="mt-2 truncate font-heading text-xl font-bold text-primary-600">
                  {card.domain}
                </p>

                <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{card.note}</p>

                <div className="mt-5 flex items-center justify-between border-t border-background-100 pt-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-global-line"></i>
                    {card.region}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-speed-up-line"></i>
                    {card.speed}
                  </span>
                </div>

                <div className="mt-4 flex gap-2">
                  {card.status !== "offline" ? (
                    <a
                      href="#subscribe"
                      className="flex-1 whitespace-nowrap rounded-md bg-primary-500 py-2 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                    >
                      {idx === 0 ? <i className="ri-check-double-line mr-1"></i> : <i className="ri-corner-up-right-line mr-1"></i>}
                      进入入口
                    </a>
                  ) : (
                    <span className="flex-1 whitespace-nowrap rounded-md bg-background-100 py-2 text-center text-sm font-semibold text-foreground-400">
                      维护中
                    </span>
                  )}
                  <button
                    type="button"
                    className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                    aria-label={`复制${card.domain}`}
                  >
                    <i className="ri-file-copy-line"></i>
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default CurrentEntries;